export const Toggle = ({ label, checked, onChange, className = '' }) => {
  return (
    <label className={`group flex cursor-pointer items-center space-x-2 ${className}`}>
      <div className="relative">
        <input type="checkbox" checked={checked} onChange={onChange} className="sr-only" />
        <div
          className={`h-[24px] w-11 rounded-full border shadow drop-shadow-sm group-hover:shadow-md ${
            checked
              ? 'border-accent-400 bg-accent-400'
              : 'border-b-0 border-r-0 border-white/50 bg-white/50 backdrop-blur-sm group-hover:bg-white/80'
          } backdrop-blur-sm transition-all duration-300`}
        ></div>
        <div
          className={`absolute left-[2px] top-[1px] h-[22px] w-[22px] rounded-full bg-white shadow-md backdrop-blur-lg transition-all duration-300 ${
            checked ? 'translate-x-[11px]' : 'translate-x-0'
          }`}
        ></div>
      </div>
      {label && <span className="text-sm font-medium text-gray-700">{label}</span>}
    </label>
  )
}
